// A cleared number field must save as "no value", not as an empty string or
// a zero. `+''` is 0 and the old background handler kept '' as text; either
// one fails the number type in the Company model, and in the production
// build that silently blanks the whole section on the next load.
export const numberInputValue = (raw) => {
  if (raw === undefined || raw === null || raw === '') return undefined;
  const n = Number(raw);
  return Number.isFinite(n) ? n : undefined;
};

export default numberInputValue;
